import React, { lazy, Suspense } from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import retry from '@wix/da-shared-react/pkg/utils/webpack/chunkRetry';

const LoadableRedux = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "exclusive_transaction_history" */
        './TransactionHistoryModal/redux/TransactionHistoryModuleLoader'
      )
  )
);

const LoadableModal = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "exclusive_transaction_history" */
        './TransactionHistoryModal'
      )
  )
);

interface Props {
  deviation?: PapiDeviation;
  onRequestClose: () => void;
}

const TransactionHistoryModalLoadable: React.FC<Props> = props => (
  <ErrorBoundary debugComponent="SellerModalLoadable">
    <Suspense
      fallback={<LoadingIndicator view={'llama'} withOverlay usePortal />}
    >
      <LoadableRedux />
      <LoadableModal {...props} />
    </Suspense>
  </ErrorBoundary>
);
TransactionHistoryModalLoadable.displayName = 'TransactionHistoryModalLoadable';

export default TransactionHistoryModalLoadable;
